import React, {useEffect, useState} from 'react'
import {useParams, useLocation} from 'react-router-dom'
import {PDFViewer} from '@react-pdf/renderer'
import DopWizardPdfDocument from './components/DopWizardPdfDocument'
import {fetchPanelWizzardDop} from '../../../api/paneliDop'
import {getSifraDetails} from '../../../api/paneliSifre'

const DopWizardPdfPage = () => {
    console.log('PDF PAGE RENDER')
    const {id} = useParams()
    const location = useLocation()

    const params = new URLSearchParams(location.search)

    const debljina = params.get('debljina')
    const lang = params.get('lang') || 'bs'

    const brojNaloga = params.get('brojNaloga')
    const stavka = params.get('stavka')
    const sifraArtikla = params.get('sifraArtikla')

    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {

        if (!id) return

        const load = async () => {


            try {

                const response = await fetchPanelWizzardDop(Number(id))

                let sifraDetails: any = null

                if (sifraArtikla) {
                    try {

                        sifraDetails = await getSifraDetails(sifraArtikla)

                        console.log('SIFRA DETAILS:', sifraDetails)

                    } catch (e) {

                        console.error('SIFRA DETAILS ERROR:', e)

                    }
                }

                console.log('FULL RESPONSE:', response)

                console.log('DOP:', response?.dop)
                console.log('DOP ITEMS:', response?.dopItems)
                console.log('MATRIX:', response?.matrix)
                console.log('DEBLJINE:', response?.debljine)

                /*
                 EXPECTED STRUCTURE:

                 {
                    dop: {...},
                    dopItems: [...],
                    matrix: {...},
                    debljine: [...]
                 }
                */

                setData({

                    // if backend returns dop object
                    ...(response?.dop || response),

                    // explicit fields
                    dop: response?.dop || response,
                    dopItems: response?.dopItems || [],
                    matrix: response?.matrix || {},
                    debljine: response?.debljine || [],
                    debljineLimova: response?.debljineLimova || [],

                    debljinaLimaGore: sifraDetails?.debljinaLimaGore || null,
                    debljinaLimaDole: sifraDetails?.debljinaLimaDole || null,

                    // local params
                    selectedDebljina: sifraDetails?.debljina,
                    lang,
                    brojNaloga,
                    stavka,
                    sifraArtikla
                })

            } catch (e) {

                console.error('PDF LOAD ERROR:', e)

            } finally {

                setLoading(false)

            }
        }

        load()

    }, [id, debljina, lang])

    console.log('FINAL PDF DATA:', data)

    if (loading || !data) {

        return (
            <div className='p-10 text-center'>
                Učitavanje...
            </div>
        )
    }

    return (

        <PDFViewer
            width='100%'
            height='900'
        >

            <DopWizardPdfDocument {...data} />

        </PDFViewer>

    )
}

export default DopWizardPdfPage